import { render, staticRenderFns } from "./CallBackPage.vue?vue&type=template&id=3f019c1a&"
import script from "./CallBackPage.vue?vue&type=script&lang=js&"
export * from "./CallBackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports